import $store from '@/store'
import { createDeviceDetector } from 'next-vue-device-detector'
import { createRouter, createWebHashHistory } from 'vue-router'
import { ElMessage } from 'element-plus'
import Layout from '@/views/layout/layout'
import RelayStation from '@/views/layout/relayStation'
import { filterLoginPath } from '@/utils/filterLoginPath.js'
import { filterHost } from '@/utils/filterHost.js'
import { showFailToast } from 'vant'

const device = createDeviceDetector()

const routes = [
  {
    path: '/',
    name: '/',
    redirect: '/processWatch',
    component: Layout,
    meta: { title: 'Layout' },
    children: [
      {
        path: '/processWatch',
        name: 'processWatch',
        component: () => import(/* webpackChunkName: "processWatch" */ './../views/processWatch/processWatch.vue'),
        meta: { title: '流程监控', icon: 'menuIcon_1', code: 'pms:process_monitor' },
      },
      // 弃用中
      // {
      //   path: '/siteNoticeDetail',
      //   name: 'siteNoticeDetail',
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "processWatch" */ './../views/processWatch/components/siteNoticeDetail'
      //     ),
      //   meta: { title: '站点信息详情', hidden: true },
      // },
      // {
      //   path: '/helpCenter',
      //   name: 'helpCenter',
      //   component: () => import(/* webpackChunkName: "helpCenter" */ './../views/helpCenter/helpCenter.vue'),
      //   meta: { title: '帮助中心', icon: 'menuIcon_3', code: 'pms:background_help_center' },
      // },
      {
        path: '/userManagement',
        name: 'userManagement',
        component: RelayStation,
        meta: {
          title: '用户管理',
          isParent: true,
          icon: 'menuIcon_2',
          code: 'pms:user_management',
        },
        children: [
          {
            path: '/staffManagement',
            name: 'staffManagement',
            component: () => import(/* webpackChunkName: "staffManagement" */ '@/views/userManagement/staffManagement.vue'),
            meta: { title: '团队管理', code: 'pms:team_management' },
          },
          {
            path: '/expertManagement',
            name: 'expertManagement',
            component: () => import(/* webpackChunkName: "expertManagement" */ './../views/userManagement/expertManagement.vue'),
            meta: { title: '专家管理', code: 'pms:broker_business' },
          },
          {
            path: '/staffManagement/staffList',
            name: 'staffList',
            component: () => import(/* webpackChunkName: "staffList" */ './../views/userManagement/staffList'),
            meta: { title: '员工列表', hidden: true },
          },
          {
            path: '/staffManagement/adminInfoConfig',
            name: 'adminInfoConfig',
            component: () => import(/* webpackChunkName: "adminInfoConfig" */ './../views/userManagement/adminInfoConfig'),
            meta: { title: '合作商信息配置', hidden: true },
          },
          {
            path: '/customerManagement',
            name: 'customerManagement',
            component: () => import(/* webpackChunkName: "customerManagement" */ './../views/userManagement/customerManagement.vue'),
            meta: { title: '客户管理', code: 'pms:customer_management' },
          },
          {
            path: '/customerDetail',
            name: 'customerDetail',
            component: () => import(/* webpackChunkName: "customerManagement" */ './../views/userManagement/customerDetail.vue'),
            meta: { title: '客户详情', hidden: true },
          },
          {
            path: '/roleManagement',
            name: 'roleManagement',
            component: () => import(/* webpackChunkName: "roleManagement" */ './../views/roleManagement/roleManagement.vue'),
            meta: { title: '角色管理', code: 'pms:role_management' },
          },
        ],
      },
      // {
      //   path: '/roleManagement',
      //   name: 'roleManagement',
      //   component: () => import(/* webpackChunkName: "roleManagement" */ './../views/roleManagement/roleManagement'),
      //   meta: { title: '角色管理', icon: 'menuIcon_5' }
      // },
      {
        path: '/reportManagement',
        name: 'reportManagement',
        component: () => import(/* webpackChunkName: "reportManagement" */ '@/views/reportManagement/reportManagement.vue'),
        meta: { title: '报告管理', icon: 'menuIcon_3', code: 'pms:report_management' },
      },
      {
        path: '/stationTool',
        name: 'stationTool',
        component: RelayStation,
        meta: { title: '站点工具', isParent: true, icon: 'menuIcon_4', code: 'pms:site_tools' },
        children: [
          {
            path: '/financeService',
            name: 'financeService',
            component: () => import(/* webpackChunkName: "financeService" */ './../views/stationTools/financeService/financeService.vue'),
            meta: { title: '融资服务' },
          },
          {
            path: '/incomingManagement',
            name: 'incomingManagement',
            component: () => import(/* webpackChunkName: "financeService" */ './../views/stationTools/incomingManagement/incomingManagement.vue'),
            meta: { title: '进件管理', code: 'pms:product_apply_management' },
          },
          {
            path: '/policyManagement',
            name: 'policyManagement',
            component: () => import(/* webpackChunkName: "financeService" */ './../views/stationTools/policyManagement/policyManagement.vue'),
            meta: { title: '政策管理', code: 'pms:policy_management' },
            // meta: { title: '政策管理', code: 'pms:policy_management' },
          },
          {
            path: '/fsProduct',
            name: 'fsProduct',
            component: () => import(/* webpackChunkName: "fsProduct" */ './../views/stationTools/financeService/fsProduct.vue'),
            meta: { title: '产品', hidden: true },
          },
          {
            path: '/fsProductSort',
            name: 'fsProductSort',
            component: () => import(/* webpackChunkName: "fsProductSort" */ './../views/stationTools/financeService/fsProductSort'),
            meta: { title: '产品排序', hidden: true },
          },
          {
            path: '/enterpriseDueDiligence',
            name: 'enterpriseDueDiligence',
            component: () => import(/* webpackChunkName: "financeService" */ './../views/EnterpriseDueDiligence/whiteList.vue'),
            meta: { title: '企业尽调' },
          },

          {
            path: '/supplyChain',
            name: 'supplyChain',
            component: () => import(/* webpackChunkName: "supplyChain" */ '@/views/supplyChain/supplyChain.vue'),
            meta: { title: '供应链信息', code: 'pms:supply_chain_info' },
          },
          {
            path: '/supplyChain/goodsApproval',
            name: 'goodsApproval',
            component: () => import(/* webpackChunkName: "goodsApproval" */ '@/views/supplyChain/goodsApproval.vue'),
            meta: { title: '产品审核', hidden: true },
          },
          {
            path: '/serverVisitNumber',
            name: 'serverVisitNumber',
            component: () => import('./../views/serviceManagementMenu/serviceManagementDetail/serverVisitNumber.vue'),
            meta: { title: '咨询量', hidden: true },
          },
          {
            path: '/aiInterpretationInfo',
            name: 'aiInterpretationInfo',
            component: () => import('./../views/aiInterpretation/aiInterpretationInfo.vue'),
            meta: { title: 'AI智能应用配置', hidden: true },
          },
        ],
      },
      {
        path: '/financialMgt',
        name: 'financialMgt',
        component: RelayStation,
        meta: {
          title: '财务管理',
          isParent: true,
          icon: 'menuIcon_5',
          code: 'pms:financial_management',
        },
        children: [
          {
            path: '/channelPromotionMgt',
            name: 'channelPromotionMgt',
            component: () => import(/* webpackChunkName: "financialMgt" */ './../views/financialMgt/channelPromotionMgt/index.vue'),
            meta: { title: '财务明细', code: ['pms:recharge_account', 'pms:promote_account'] },
            children: [
              {
                path: '/withdrawal',
                name: 'withdrawal',
                component: () => import(/* webpackChunkName: "financialMgt" */ './../views/financialMgt/channelPromotionMgt/Withdrawal/index.vue'),
                meta: { title: '提现' },
              },
            ],
          },
          {
            path: '/withdrawalManagement',
            name: 'withdrawalManagement',
            component: () => import(/* webpackChunkName: "financialMgt" */ './../views/financialMgt/withdrawalManagement/index.vue'),
            meta: { title: '提现管理', code: ['pms:commission_management'] },
          },
          {
            path: '/commissionDetail',
            name: 'commissionDetail',
            component: () => import(/* webpackChunkName: "financialMgt" */ '@/views/financialMgt/commissionDetail/index.vue'),
            meta: { title: '佣金明细', code: 'pms:commission_detail' },
          },
          {
            path: '/viewCommissionDetail/:type/:id',
            name: 'viewCommissionDetail',
            component: () => import(/* webpackChunkName: "financialMgt" */ '@/views/financialMgt/commissionDetail/viewCommissionDetail.vue'),
            meta: { title: '查看佣金明细', hidden: true },
          },
          {
            path: '/orderManagement',
            name: 'orderManagement',
            component: () => import(/* webpackChunkName: "financialMgt" */ './../views/financialMgt/orderManagement/index.vue'),
            meta: { title: '订单管理', code: 'pms:order_management' },
          },
          {
            path: '/costAallocation',
            name: 'costAallocation',
            component: () => import(/* webpackChunkName: "financialMgt" */ '@/views/financialMgt/costAallocation/index.vue'),
            meta: { title: '费用配置', code: 'pms:cost_configuration' },
            children: [
              {
                path: '/partnerDetails/:channelid',
                name: 'partnerDetails',
                component: () => import(/* webpackChunkName: "financialMgt" */ './../views/financialMgt/costAallocation/partnerDetails/partnerDetails.vue'),
                meta: { title: '合作商明细' },
              },
            ],
          },
          {
            path: '/payWhiteList',
            name: 'payWhiteList',
            component: () => import(/* webpackChunkName: "payWhiteList" */ './../views/financialMgt/authPayWhiteList'),
            meta: { title: '企业免费授权配置', code: 'pms:authorize_whitelist' },
          },
          {
            path: '/invoiceManagement',
            name: 'invoiceManagement',
            component: () => import(/* webpackChunkName: "invoiceManagement" */ './../views/financialMgt/invoiceManagement.vue'),
            meta: { title: '开票管理', code: 'pms:finance_invoice' },
          },
          {
            path: '/invitationManagement',
            name: 'invitationManagement',
            component: () => import(/* webpackChunkName: "invitationManagement" */ './../views/financialMgt/invitationManagement.vue'),
            meta: { title: '邀请明细', code: 'pms:invite_user' },
          },
        ],
      },
      {
        path: '/loading',
        name: 'loading',
        component: () => import(/* webpackChunkName: "loading" */ './../views/layout/loading.vue'),
        meta: { title: '加载中...', hidden: true },
      },
      // {
      //   path: '/infoConfig',
      //   name: 'infoConfig',
      //   component: () => import(/* webpackChunkName: "processWatch" */ './../views/infoConfig/index.vue'),
      //   meta: { title: '信息配置', icon: 'menuIcon_1', code: 'pms:configuration_info' },
      // },
      // {
      //   path: '/customReport',
      //   name: 'customReport',
      //   component: () => import(/* webpackChunkName: "processWatch" */ '../views/customReport/customReport.vue'),
      //   meta: { title: '自定义报告', icon: 'menuIcon_1', code: 'pms:report_define' },
      // },
      {
        path: '/brandInfo',
        name: 'brandInfo',
        component: RelayStation,
        meta: { title: '品牌信息配置', isParent: true, icon: 'menuIcon_6', code: 'pms:brand_info_config' },
        children: [
          {
            path: '/commonInfo',
            name: 'commonInfo',
            component: () => import(/* webpackChunkName: "commonInfo" */ '../views/brandInfo/commonInfo.vue'),
            meta: { title: '公共信息配置', code: 'pms:public_info_config' },
          },
          {
            path: '/customReport',
            name: 'customReport',
            // redirect: { name: 'customReportBlank' },
            component: () => import(/* webpackChunkName: "customReport" */ '../views/customReport/customReport.vue'),
            meta: { title: '报告信息配置', code: 'pms:report_define' },
          },
          {
            path: '/enterpriseInfo',
            name: 'enterpriseInfo',
            component: () => import(/* webpackChunkName: "enterpriseInfo" */ '../views/brandInfo/enterpriseInfo.vue'),
            meta: { title: '企业端配置', code: 'pms:configuration_info' },
          },
        ],
      },
      {
        path: '/aiInterpretation',
        name: 'aiInterpretation',
        component: () => import('./../views/aiInterpretation/aiInterpretation.vue'),
        meta: { title: 'AI智能应用配置', icon: 'menuIcon_3', code: 'pms:ai_intelligent_app' },
      },
      {
        path: '/miniProgramDetail',
        name: 'miniProgramDetail',
        component: () => import('./../views/enterpriseConfiguration/miniProgramDetail.vue'),
        meta: { title: '小程序详情', hidden: true, code: 'pms:applet_info_config' },
      },
      {
        path: '/miniProgramInformationConfiguration',
        name: 'miniProgramInformationConfiguration',
        component: RelayStation,
        meta: { title: '小程序信息配置', isParent: true, icon: 'menuIcon_3', code: 'pms:applet_manage' },
        children: [
          {
            path: '/enterpriseConfiguration',
            name: 'enterpriseConfiguration',
            component: () => import('./../views/enterpriseConfiguration/enterpriseConfiguration.vue'),
            meta: { title: '小程序配置', code: 'pms:applet_info_config' },
          },
          {
            path: '/serviceManagement',
            name: 'serviceManagement',
            component: () => import('./../views/serviceManagementMenu/serviceManagement/serviceManagement.vue'),
            meta: { title: '服务管理', code: 'pms:service_management' },
          },
          {
            path: '/appletRecommendedConfiguration',
            name: 'appletRecommendedConfiguration',
            component: () => import('./../views/applet/recommendedConfiguration/recommendedConfiguration.vue'),
            meta: { title: '推荐配置', code: 'pms:recommended_cfg' },
          },
          {
            path: '/miniProgramServiceManagement',
            name: 'miniProgramServiceManagement',
            component: () => import('./../views/miniProgramServiceManagement/miniProgramServiceManagement.vue'),
            meta: { title: '小程序客服管理', code: 'pms:wxapp_kf' },
          },
          {
            path: '/serviceManagementDetail',
            name: 'serviceManagementDetail',
            component: () => import('./../views/serviceManagementMenu/serviceManagementDetail/serviceManagementDetail.vue'),
            meta: { title: '服务详情', hidden: true },
          },
          {
            path: '/serviceApplyDetail',
            name: 'serviceApplyDetail',
            component: () => import('./../views/serviceManagementMenu/serviceApplyDetail/serviceApplyDetail.vue'),
            meta: { title: '报名详情', hidden: true },
          },
          {
            path: '/newsInformation',
            name: 'newsInformation',
            component: () => import('./../views/newsInformation/newsInformation.vue'),
            meta: { title: '新闻资讯', code: 'pms:news' },
          },
          {
            path: '/addNewsInformation',
            name: 'addNewsInformation',
            component: () => import('./../views/newsInformation/addNewsInformation.vue'),
            meta: { title: '添加资讯', hidden: true },
          },
          {
            path: '/vipCenter',
            name: 'vipCenter',
            component: RelayStation,
            meta: { title: '会员中心', isParent: true, icon: 'menuIcon_9', code: 'pms:vip_center_parent' },
            children: [
              {
                path: '/vipConfig',
                name: 'vipConfig',
                component: () => import('./../views/vipCenter/index.vue'),
                meta: { title: '会员配置', code: 'pms:vip_center' },
              },
              {
                path: '/vipManagement',
                name: 'vipManagement',
                component: () => import(/* webpackChunkName: "vipManagement" */ './../views/financialMgt/vipManagement.vue'),
                meta: { title: '会员管理', code: 'pms:vip_account' },
              },
            ],
          },
        ],
      },
      {
        path: '/brokerBusiness',
        name: 'brokerBusiness',
        component: RelayStation,
        meta: { title: '专家业务管理', isParent: true, icon: 'menuIcon_7', code: 'pms:broker_business' },
        children: [
          {
            path: '/brokerService',
            name: 'brokerService',
            component: () => import(/* webpackChunkName: "brokerService" */ '../views/brokerBusiness/brokerService.vue'),
            meta: { title: '解读管理', code: 'pms:broker_service' },
          },
          {
            path: '/serviceOrderManagement',
            name: 'serviceOrderManagement',
            component: () => import(/* webpackChunkName: "serviceOrderManagement" */ './../views/financialMgt/serviceOrderManagement/index.vue'),
            meta: { title: '服务订单管理', code: 'pms:service_order_manage' },
          },
        ],
      },
      {
        path: '/helpCenterMenu',
        name: 'helpCenterMenu',
        component: RelayStation,
        meta: { title: '帮助管理', isParent: true, icon: 'menuIcon_3', code: 'pms:background_help_center' },
        children: [
          {
            path: '/helpCenter',
            name: 'helpCenter',
            component: () => import(/* webpackChunkName: "helpCenter" */ './../views/helpCenterMenu/helpCenter.vue'),
            meta: { title: '帮助中心', code: 'pms:background_help_center' },
          },
          {
            path: '/suggestManagement',
            name: 'suggestManagement',
            component: () => import('./../views/helpCenterMenu/suggestManagement/index.vue'),
            // meta: { title: '建议管理', code: 'pms:background_advice_mgt' },
            meta: { title: '建议管理', hidden: true, code: 'pms:background_advice_mgt' },
          },
          {
            path: '/messageNotification',
            name: 'messageNotification',
            component: () => import(/* webpackChunkName: "messageNotification" */ './../views/helpCenterMenu/messageNotification.vue'),
            meta: { title: '消息通知', hidden: true, code: 'pms:background_message' },
          },
        ],
      },
      // {
      //   path: '/marketingCenter',
      //   name: 'marketingCenter',
      //   component: () => import(/* webpackChunkName: "marketingCenter" */ '@/views/marketingCenter/marketingCenter.vue'),
      //   meta: { title: '营销中心', icon: 'menuIcon_8', code: 'pms:market_center' },
      // },
      {
        path: '/marketingCenter',
        name: 'marketingCenter',
        component: RelayStation,
        meta: { title: '营销中心', isParent: true, icon: 'menuIcon_3', code: 'pms:market_center' },
        children: [
          {
            path: '/activityCenter',
            name: 'activityCenter',
            component: () => import(/* webpackChunkName: "marketingCenter" */ '@/views/marketingCenter/marketingCenter.vue'),
            meta: { title: '活动管理', icon: 'menuIcon_8', code: 'pms:free_welfare_manage' },
          },
          {
            path: '/enterpriseDetail/:welfare_id',
            name: 'enterpriseDetail',
            component: () => import(/* webpackChunkName: "enterpriseDetail" */ '@/views/marketingCenter/child/enterpriseDetail.vue'),
            meta: { title: '企业详情', hidden: true },
          },
          {
            path: '/coupon',
            name: 'coupon',
            component: () => import(/* webpackChunkName: "couponManagement" */ '@/views/marketingCenter/couponManagement.vue'),
            meta: { title: '优惠券管理', icon: 'menuIcon_8', code: 'pms:coupon_manage' },
          },
        ],
      },
    ],
  },
  {
    path: '/customReportBlank',
    name: 'customReportBlank',
    component: () => import(/* webpackChunkName: "customReport" */ '../views/customReport/customReport.vue'),
    meta: { title: '报告信息配置', code: 'pms:report_define' },
  },
  {
    path: '/reportConfig',
    name: 'reportConfig',
    component: () => import(/* webpackChunkName: "reportConfig" */ './../views/customReport/components/reportConfig/index.vue'),
    meta: { title: '报告配置', parentPath: '/customReport' },
  },
  {
    path: '/previewReportConfig',
    name: 'previewReportConfig',
    component: () => import(/* webpackChunkName: "reportConfig" */ './../views/customReport/components/reportConfig/index.vue'),
    meta: { title: '报告配置', parentPath: '/customReport' },
  },
  {
    path: '/overallFinancingService',
    name: 'overallFinancingService',
    component: () => import(/* webpackChunkName: "reportConfig" */ '@/views/stationTools/financeService/financeService.vue'),
    meta: { title: '融资服务全局' },
  },
  {
    path: '/overallProduct',
    name: 'overallProduct',
    component: () => import(/* webpackChunkName: "fsProduct" */ '@/views/stationTools/financeService/fsProduct.vue'),
    meta: { title: '产品全局' },
  },
  {
    path: '/overallProductSort',
    name: 'overallProductSort',
    component: () => import(/* webpackChunkName: "fsProductSort" */ './../views/stationTools/financeService/fsProductSort'),
    meta: { title: '产品排序全局' },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/login.vue'),
    meta: { title: '登录' },
  },
  {
    path: '/publicLogin',
    name: 'publicLogin',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/publicLogin.vue'),
    meta: { title: '登录' },
  },
  {
    path: '/loginCommon',
    name: 'loginCommon',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/loginCommon.vue'),
    meta: { title: '登录身份' },
  },
  {
    path: '/forgotPwd',
    name: 'forgotPwd',
    component: () => import(/* webpackChunkName: "login" */ '../views/login/forgotPwd.vue'),
    meta: { title: '忘记密码' },
  },
  {
    path: '/authPage',
    name: 'authPage',
    component: () => import(/* webpackChunkName: "authPage" */ '../views/AuthPage/index.vue'),
    meta: { title: '授权页面' },
  },
  {
    path: '/transit',
    name: 'transit',
    component: () => import(/* webpackChunkName: "authPage" */ '../views/transit/transit.vue'),
    meta: { title: '账户一体化,统一获取登陆信息,中转页面' },
  },
]

const mobileRoutes = [
  {
    path: '/',
    redirect: '/analyse',
  },
  {
    path: '/login',
    component: () => import('../mobile/views/Login/index.vue'),
  },
  {
    path: '/publicLogin',
    component: () => import('../mobile/views/Login/publicLogin.vue'),
  },
  {
    path: '/loginCommon',
    component: () => import('../mobile/views/Login/loginCommon.vue'),
  },
  {
    path: '/analyse',
    name: 'analyse',
    component: () => import('../mobile/views/Analyse/index.vue'),
    meta: {
      isShow: true,
    },
  },
  {
    path: '/profile',
    component: () => import('../mobile/views/Profile/index.vue'),
    meta: {
      isShow: true,
    },
  },
  {
    path: '/transit',
    name: 'transit',
    component: () => import(/* webpackChunkName: "authPage" */ '../views/transit/transit.vue'),
    meta: { title: '账户一体化,统一获取登陆信息,中转页面' },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/analyse',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes: device.mobile ? mobileRoutes : routes,
})

// 跳转白名单
const jumpWhiteList = [
  '/login',
  '/loginCommon',
  '/publicLogin',
  '/forgotPwd',
  '/loading',
  '/authPage',
  '/customReportBlank',
  '/transit',
  '/overallFinancingService',
  '/overallProduct',
  '/overallProductSort',
]

// 检测路由权限
function checkPermission(matched) {
  // 是否允许
  let allow = true
  // 检测整个匹配链是否有权限
  if (matched && matched.length > 0) {
    matched.find((item) => {
      // 权限code存在字符串和数组两种情况
      // 字符串：必须在功能权限检测函数中通过
      // 数组：其中包含的某一项必须在功能权限检测函数中通过
      const code = item.meta.code
      const codeList = Array.isArray(code) ? code : code ? [code] : ''
      if (codeList && codeList.length > 0) {
        // 是否存在功能权限
        const exist = codeList.some((cItem) => $store.getters.checkFunctionalPermission(cItem))
        // 存在权限，设置true，不存在，驳回
        allow = exist ? true : false
        // 存在权限，继续检测下一条路由
        return exist ? false : true
      } else {
        // 无需检测
        return false
      }
    })
  } else {
    // 匹配链不存在，驳回
    allow = false
  }
  return allow
}
// 判断设备,添加对应的导航守卫
if (!device.mobile) {
  const token = localStorage.getItem('wp_ct-channel-token')
  // 路由参数守卫
  router.beforeEach((to, from, next) => {
    // console.log('路由参数守卫-to', to)
    // console.log('路由参数守卫-from', from)
    const currentHost = window.location.host
    // 新路由中的站点信息
    const toStationInfo = to.query.partner_code
    const partner_code = localStorage.getItem('wp_partner_code')
    const channelUserToken = localStorage.getItem('integration_channel_user_token')
    // const accountIntegrationLoginSuccess = localStorage.getItem('integration_loginSuccess')
    if (!channelUserToken && filterHost()) {
      if (to.path.includes('transit')) {
        next()
      } else {
        window.location.href = filterLoginPath()
      }
    }
    if (to.path.startsWith('/publicLogin')) {
      if (token && partner_code) {
        next(`/processWatch?partner_code=${partner_code}`)
      } else {
        next()
      }
    }
    if (toStationInfo) {
      // 有，直接进入
      localStorage.setItem('wp_partner_code', toStationInfo)
      next()
    } else {
      // 上个路由中的站点信息
      const fromStationInfo = from.query.partner_code
      // 只有页面不是统一登录页面才会加上缓存的partner_code
      if (fromStationInfo && to.path != '/publicLogin' && to.path != '/loginCommon') {
        // 设置站点信息
        to.query.partner_code = fromStationInfo
        localStorage.setItem('wp_partner_code', fromStationInfo)
        next(to)
      } else {
        // 新路由的path
        const toPath = to.path
        // 来自页面的路由
        const fromPath = from.path
        // 只要不是统一登录入口的相关页面没有partner_code，就提示用户
        if (!['/loginCommon', '/publicLogin', '/authPage', '/transit', '/loading'].includes(toPath)) {
          // 在有效页面，进行提示
          ElMessage.error({
            message: '地址错误，未获取到站点信息！',
            grouping: true,
          })
          localStorage.removeItem('wp_partner_code')
        }
        if (['/login', '/loginCommon', '/publicLogin', '/authPage', '/transit', '/loading'].includes(toPath)) {
          // 登录页面，通过
          next()
        } else if (fromPath == '/') {
          // 未进入任何页面，重定向到登录页面
          next('/login')
        } else {
          // 其他页面，停止
          next(false)
        }
      }
    }
  })

  // 页面跳转守卫
  router.beforeEach((to, from, next) => {
    // console.log('页面跳转守卫', to, from, $store);
    // 是否白名单路由
    const isWhite = jumpWhiteList.includes(to.path)
    if (isWhite) {
      next()
    } else {
      // 非白名单，进行鉴权
      // to是否允许
      const toAllow = checkPermission(to.matched)
      if (toAllow) {
        next()
      } else {
        // 如to不允许
        // from是否允许
        const fromAllow = checkPermission(from.matched)
        if (fromAllow) {
          // from是允许的页面，返回
          next(false)
        } else {
          // from是不允许的页面，进入有权限的默认页面，否则，返回登录页面
          let nodePath = '/login'
          // 没有用户信息，进入loading页面，等待用户信息设置
          console.log('$store.state.userInfo', $store.state.userInfo)
          if (!$store.state.userInfo) {
            nodePath = '/loading'
          }
          if (!token) {
            nodePath = '/login'
            next({ path: nodePath, query: to.query || from.query })
          }
          next({
            path: $store.state.fpDefaultPath || nodePath,
            query: Object.assign(
              {
                toPath: encodeURIComponent(to.path),
              },
              to.query || from.query,
            ),
          })
        }
      }
    }
  })
} else {
  // 如果是移动端
  router.beforeEach((to, from, next) => {
    // 手机端、跳转白名单
    const MobileJumpWhiteList = ['/loginCommon', '/publicLogin', '/transit']
    const token = localStorage.getItem('wp_ct-channel-token')
    const partner_code = to.query?.partner_code || from.query?.partner_code
    const channelUserToken = localStorage.getItem('integration_channel_user_token')
    if (!channelUserToken && filterHost()) {
      if (to.path.includes('transit')) {
        next()
      } else {
        window.location.href = filterLoginPath()
      }
    }
    if (!partner_code && !MobileJumpWhiteList.includes(to.path)) {
      showFailToast('地址错误，未获取到站点信息！')
    }
    if (partner_code) {
      localStorage.setItem('ws_partner_code', partner_code)
    }
    if (MobileJumpWhiteList.includes(to.path)) {
      next()
    } else {
      if (!token && to.path !== '/login') {
        const partner_code = localStorage.getItem('ws_partner_code')
        if (partner_code) {
          next({
            path: '/login',
            query: {
              partner_code,
            },
          })
        }
        next({ path: '/login' })
      }
      next()
    }
  })
}

export default router
export { device }
